<div class="event__profile">
  <div class="settings d-flex flex-row">
    <!-- <mat-icon>more_vert</mat-icon> -->
  </div>
  <div class="event__wrapper d-flex flex-row">
    <div class="d-flex flex-row">
      <img src="./assets/images/icons/venue-logo-placeholder-01.svg " alt="profile-picture">
      <div class="event__info">
        <h4>{{company.companyName}}</h4>
        <!-- <p>{{companyTypesString}}</p> -->
        <a class="user__link" href="{{ company.websiteUrl }}" target="_blank">{{ company.websiteUrl }}</a>
      </div>
    </div>
    <div class="d-flex flex-row">
      <!-- <div>Select Venue component</div> -->
    </div>
  </div>
</div>

<div class="events__container">
  <div class="settings d-flex flex-row">
    <!-- <mat-icon>more_vert</mat-icon> -->
  </div>
  <div class="events__header d-flex flex-row">
    <div>
      <h4>{{ 'EVENTS.EVENTS' | translate }}</h4>
    </div>
    <!-- <div>
        <div>{{totalRecords}}</div>
    </div>
    <div>
      <div>
        Search Component
      </div>
    </div> -->
  </div>
</div>

<div class="events__tabs-container">
  <div class="events__eventtabs d-flex flex-row">
    <div>
      <p-tabView (onChange)="changeTabView($event)" [activeIndex]="selectedTab" #tabView>
        <p-tabPanel>
          <ng-template pTemplate="header">
            <i class="pi pi-fw pi-bell"></i>
            <label style="cursor: pointer;">{{'EVENTS.LIVE'|translate}} <span class="color_mono_txt"></span></label>
          </ng-template>
          <div>
            <ng-container *ngTemplateOutlet="eventTemplate"></ng-container>
          </div>
        </p-tabPanel>
        <p-tabPanel>
          <ng-template pTemplate="header">
            <label style="cursor: pointer;">{{'EVENTS.PUBLISHED' | translate }} <span
              class="color_mono_txt"></span></label>
          </ng-template>
          <div>
            <ng-container *ngTemplateOutlet="eventTemplate"></ng-container>
          </div>
        </p-tabPanel>
        <p-tabPanel>
          <ng-template pTemplate="header">
            <label style="cursor: pointer;">{{'EVENTS.DRAFT' | translate }}<span class="color_mono_txt"></span></label>
          </ng-template>
          <div>
            <ng-container *ngTemplateOutlet="eventTemplate"></ng-container>
          </div>
        </p-tabPanel>
        <p-tabPanel>
          <ng-template pTemplate="header">
            <label style="cursor: pointer;">{{'EVENTS.PAST' | translate }}<span class="color_mono_txt"></span></label>
          </ng-template>
          <div>
            <ng-container *ngTemplateOutlet="eventTemplate"></ng-container>
          </div>
        </p-tabPanel>
        <p-tabPanel>
          <ng-template pTemplate="header">
            <div>
              <button class="btn-create-event btn-full"
                      (click)="createEvent()">{{ 'EVENTS.CREATE_NEW_EVENT' | translate}}</button>
            </div>
          </ng-template>
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>
</div>

<ng-template #eventTemplate>
      <div *ngIf="eventList?.length != 0 && (!loadingPage || !(loadingPage && this.searchEventModel.pageNumber === 1))">
        <div class="list-events" infiniteScroll
             [infiniteScrollDistance]="2"
             [infiniteScrollUpDistance]="1000"
             (scrolled)="loadMoreEvents()"
             [scrollWindow]="false"
             #dataContainer>
          <div *ngFor="let event of eventList" class="component-card">
            <app-event-item class="list-events__container" [event]="event"></app-event-item>
          </div>
        </div>
      </div>
</ng-template>

<p-toast position="center" key="company-check" (onClose)="onRejectCompanyCheck()" [baseZIndex]="5000">
  <ng-template let-message pTemplate="message">
    <div class="flex flex-column" style="flex: 1">
      <div class="text-center pb-4">
        <i class="pi pi-info-circle" style="font-size: 3rem"></i>
        <!-- <h5> create Event</h5> -->
        <h5>{{ 'EVENTS.CHECK_COMPANY' | translate }}</h5>
      </div>
    </div>
  </ng-template>
</p-toast>

<p-toast position="center" key="venues-check" (onClose)="onRejectVenuesCheck()" [baseZIndex]="5000">
  <ng-template let-message pTemplate="message">
    <div class="flex flex-column" style="flex: 1">
      <div class="text-center pb-4">
        <i class="pi pi-info-circle" style="font-size: 3rem"></i>
        <!-- <h5> create Event</h5> -->
        <h5>{{ 'EVENTS.CHECK_VENUES' | translate }}</h5>
      </div>
      <div class="p-fluid d-flex align-items-center justify-content-center">
        <div class="col-6">
          <button type="button" pButton (click)="onConfirmVenuesCheck()" label="{{ 'EVENTS.GO_TO_VENUES_PANEL' | translate }}"
            class="info"></button>
        </div>
      </div>
    </div>
  </ng-template>
</p-toast>

<ng-container *ngIf="eventList?.length === 0 && !loadingPage">
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-12 no-items">
        <div class="d-flex flex-column justify-content-center align-items-center">
          <img src="./assets/images/icons/reservations_empty@3x.png" alt="no-reservations" class="img-responsive">
          <p class="mt-2">{{ 'EVENTS.NO_EVENTS' | translate }}</p>
        </div>
      </div>
    </div>
  </div>
</ng-container>
